/* Límite de ancho de las fotos cargadas desde Mercado Libre.
   snippets/wanderth-ml-src.liquid pide la versión grande de cada foto de
   MeliSync, pero no todas lo son: si el vendedor la subió a 500 px, la "grande"
   también mide 500. Liquid no puede saberlo, así que aquí, al cargar, se pone
   --wnd-img-w con el ancho real y wanderth-custom.css deja de estirarla (así se
   ve nítida aunque algo más pequeña). También cubre el respaldo de Shopify
   cuando la de Mercado Libre falla, porque ese cambio de src vuelve a disparar
   "load". */
(function () {
  function fit(img) {
    if (!img.naturalWidth) return;
    var box = img.closest('.image-wrap, .wnd-cg__slide');
    if (box) box.style.setProperty('--wnd-img-w', img.naturalWidth + 'px');
  }

  // "load" no burbujea: se escucha en fase de captura para cubrir también
  // las fotos diferidas (loading="lazy") que cargan después.
  document.addEventListener('load', function (e) {
    var img = e.target;
    if (img.tagName === 'IMG' && img.hasAttribute('data-fallback-src')) fit(img);
  }, true);

  // Las que ya cargaron antes de que corriera este script (va con defer).
  document.querySelectorAll('img[data-fallback-src]').forEach(function (img) {
    if (img.complete) fit(img);
  });
})();
